import * as ActionType from './contant'

const initState = {
  visibleHomeSearch: false,
}

const reducer = (state = initState, action) => {
  const { type, value } = action

  switch (type) {
    case ActionType.SET_HOMESEARCH:
      return {
        ...state,
        visibleHomeSearch: value,
      }
    case ActionType.CLEAR_HOMESEARCH:
      return initState
    default:
      return state
  }
}

export default reducer
